import {
  MinersSelectionI,
  marshalSelectedMiners,
  unmarshalSelectedMiners,
  ServerSideFixMinersList,
  SelectedMinersForMarshalI
} from "@store/minersSelect/actionTypes";

export const saveMinersLocal = (selection: MinersSelectionI) => {
  const prepareMiners = marshalSelectedMiners(selection);
  const toSave = JSON.stringify(prepareMiners);
  localStorage.setItem("miners", toSave);
};

export const getSavedMiners = async (fix: ServerSideFixMinersList): Promise<[MinersSelectionI, boolean] | void> => {
  const savedString = localStorage.getItem("miners");
  if (!savedString) {
    return;
  }
  const rawData = JSON.parse(savedString);
  if (Array.isArray(rawData)) {
    return [{ selected: rawData }, false];
  }
  const data: SelectedMinersForMarshalI = rawData;
  return await unmarshalSelectedMiners(data, fix);
};
